import SvgArrowLeft from '@img/icons/arrow-left.svg';
import SvgArrowRight from '@img/icons/arrow-right.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Controls.styles';
const Controls = React.forwardRef((props, ref) => {
    const carousel = useCarouselContext();
    return (React.createElement(S.Container, { ref: ref, className: props.className },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.CarouselButton, { buttonType: props.theme ?? 'custom', iconOnly: true, icon: React.createElement(SvgArrowLeft, null), "aria-label": "Previous slide", "aria-disabled": !props.wrap && carousel.activeIndex === 0, onClick: (event) => {
                    event.preventDefault();
                    carousel.goToPrev(props.wrap);
                }, "data-prev": true })),
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.CarouselButton, { buttonType: props.theme ?? 'custom', iconOnly: true, icon: React.createElement(SvgArrowRight, null), "aria-label": "Next slide", "aria-disabled": !props.wrap && carousel.activeIndex === carousel.maxIndex, onClick: (event) => {
                    event.preventDefault();
                    carousel.goToNext(props.wrap);
                }, "data-next": true }))));
});
Controls.displayName = 'Controls';
export default Controls;
